import { createFeatureSelector } from '@ngrx/store';

import { ConfigurationState }    from '../index';

export const selectConfigurationState = createFeatureSelector<ConfigurationState>('configuration');

